import NoData from "assets/svgs/no_data/NoData";
import { isEmpty } from "lodash";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { fourPlaceHolder, getValue } from "modules/utilities/utility";
import React, { useEffect, useMemo, useState } from "react";
import { Form, Placeholder } from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import CardDiv from "modules/common/card-div/CardDiv";
import { useTagsStore } from "modules/manage_tags/store";
import ManageTagModal from "modules/manage_tags/ManageTagModal";
import { Link } from "react-router-dom";
import { Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

function ManageTag() {
  const { tagData, tagLoading,removeLoading, fetchTagData, updateActiveStatus, removeTag } =
    useTagsStore();
  const [page, newPage] = useState(1);
  const { setToaster } = useToast();
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    fetchTagData(page - 1);
  }, [page]);


  const mapTagData = useMemo(() => {
    if (isEmpty(tagData?.data)) return [];

    return tagData?.data.results.map((row) => ({
      key: getValue(row, "id"),
      tagMasterName: getValue(row, "display_name"),
      tag: getValue(row, "tag"),
      order: getValue(row, "order"),
      switch: getValue(row, "is_active"),
    }));
  }, [tagData?.data]);

  const handleCheckBox = (event, id) => {
    const check = event.target.checked ? true : false;
    updateActiveStatus(id, check, setToaster, fetchTagData);
  };

  const deleteTag=(id)=>{
    removeTag(id, setToaster, fetchTagData);
  }



  const header = ["Tag Master Name", "Tag", "Order", "Status", "Action"];

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div className="fs-2">Manage Tags</div>
            <div>
              <Button
                className="btn btn-primary"
                onClick={() => setModalShow(true)}
              >
                Add Tag
              </Button>{" "}
            </div>
          </div>
        }
        component={
          <>
            <div>
              <div className="mt-1 shadow rounded mt-2">
                <div className="d-flex table-head rounded-top">
                  {header?.map((item) => {
                    return (
                      <span className="p-3 fw-bold text-black flex-1 border-end">
                        {item}
                      </span>
                    );
                  })}
                </div>
                {tagLoading ? (
                  fourPlaceHolder()
                ) : mapTagData && mapTagData?.length ? (
                  mapTagData?.map((item, index) => {
                    return (
                      <div
                        className={`d-flex table-row border-1 border-top-0 ${
                          index === mapTagData?.length - 1 && `rounded-bottom`
                        }`}
                      >
                        <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                          <Link
                            to={`/manage-tags/tagDetail/${item?.key}/${item?.tagMasterName?.replace("#","")}`}
                            className="text-primary fw-bold"
                          >
                            {item?.tagMasterName}
                          </Link>
                        </span>
                        <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                          {item?.tag}
                        </span>
                        <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                          {item?.order}
                        </span>
                        <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                          <Form.Check
                            type="checkbox"
                            id="checkedCheckbox"
                            label={item?.switch?"Active":"Inactive"}
                            onClick={(event) =>
                              handleCheckBox(event, item?.key, item?.switch)
                            }
                            defaultChecked={item?.switch ? true : false}
                          />
                        </span>
                        <span className="p-3 d-flex gap-4 flex-1 text-break text-wrap border-end cursor-pointer text-danger">
                          <Popconfirm
                            title={
                              <div>
                                Are you sure to delete{" "}
                              </div>
                            }
                            placement="topRight"
                            onConfirm={() => deleteTag(item?.key)}
                          >
                            <Button
                              danger
                              icon={<DeleteOutlined />}
                              loading={removeLoading}
                              type="link"
                            />
                          </Popconfirm>
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <div className="p-3 bg-white rounded-bottom text-center">
                    No Data Available <NoData />
                  </div>
                )}
              </div>
            </div>
            <div>
              <PaginationDiv
                paginationData={{
                  pageCount: tagData?.data?.total
                    ? Math.ceil(tagData?.data?.total / 10)
                    : 1,
                  page: page,
                }}
                newPage={newPage}
              />
            </div>
          </>
        }
      />
      <ManageTagModal modalShow={modalShow} setModalShow={setModalShow} />
    </div>
  );
}

export default ManageTag;
